App.framer = {
	init: function() {
		const host   = window.location.hostname;
		const isDev  = host.endsWith('worksection.dev') || host === 'promo-dev.worksection.com';
		let apiBase  = isDev ? 'https://worksection.dev' : 'https://worksection.com';

		if (host === 'promo-local.worksection.dev') apiBase = 'https://' + host;

		$.support.cors = 1;
		$.ajaxSetup({
			crossDomain: true,
			beforeSend: function(xhr, settings) {
				if (settings.url.substr(0, 1) === '/') {
					settings.url = apiBase + settings.url;
				}
				if (!isDev) {
					xhr.setRequestHeader('X-framer', '1.0');
				} else {
					xhr.setRequestHeader('X-new-dev', '1.0');
				}
				xhr.url = settings.url;
			}
		});

		App.auth = App.auth || {};
		App.auth.url_base = apiBase;
		if (isDev) App.auth.force_new = true;
	},
};